import {
    otherDocumentOptions,
    personalVerificationInformationDocumentOptions,
    proofOfIncomeDocumentOptions,
    taxInformationDocumentOptions,
} from "../containers/UmmcFADocumentation/UmmcFaDropDownConstants";

export function getDocumentGroup(documentName) {
    function doesArrayContain(array, documentName) {
        const result = array.filter(x => x.value === documentName);
        return result != null && result.length > 0;
    }

    if (doesArrayContain(otherDocumentOptions, documentName)) {
        return "otherDocuments";
    }

    if (doesArrayContain(taxInformationDocumentOptions, documentName)) {
        return "taxInformationDocuments";
    }

    if (doesArrayContain(proofOfIncomeDocumentOptions, documentName)) {
        return "proofOfIncome";
    }

    if (doesArrayContain(personalVerificationInformationDocumentOptions, documentName)) {
        return "personalVerificationDocuments";
    }

    return null;
}

export function getDocumentPrettyName(documentDropdownItems, documentName) {
    let documentLabel = "";
    documentLabel = documentDropdownItems
        ?.filter(x => x.value === documentName)
        ?.map(y => {
            return y.label;
        });
    return documentLabel;
}
